import React from 'react';
import query from '@catalogo/core-queries/device.graphql';
import { useApolloClient } from '@apollo/client';
import { DeviceQuery } from '@catalogo/core-types';
import { ApolloClient } from '@apollo/client';
import { NormalizedCacheObject } from '@apollo/client/cache';

export interface WithDeviceProps {
  device?: string | null;
}
export type Client = ApolloClient<NormalizedCacheObject>;

export const withDevice = <P extends WithDeviceProps>(Component: React.FC<P>): React.FC<P & WithDeviceProps> => {
  const Connected: React.FC<P & WithDeviceProps> = props => {
    const client = useApolloClient();
    const data = client.readQuery<DeviceQuery>({
      query,
    });

    return <Component {...props} device={data && data.device} />;
  };

  return Connected;
};

export const getDevice = (client: Client): WithDeviceProps => {
  const { device } = client.readQuery({
    query,
  });

  return device;
};
